import { __read } from 'tslib';
import { useState } from 'react';
import '../hooks/useDetectInputMethod.js';
import { useId } from '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';

var useDisclosure = function (_a) {
    var _b = _a === void 0 ? {} : _a, id = _b.id, _c = _b.defaultIsOpen, defaultIsOpen = _c === void 0 ? false : _c;
    var _d = __read(useState(defaultIsOpen), 2), isOpen = _d[0], setIsOpen = _d[1];
    var autoId = useId();
    var disclosureId = id ? id : "disclosure--".concat(autoId);
    var toggleIsOpen = function () { return setIsOpen(function (prevState) { return !prevState; }); };
    return { isOpen: isOpen, setIsOpen: setIsOpen, toggleIsOpen: toggleIsOpen, id: disclosureId };
};

export { useDisclosure };
//# sourceMappingURL=useDisclosure.js.map
